import React from 'react'

const SpinnerCuadrado = () => {
    return (
        <div className={`loadingGlobal`}> 
            <div className="loadingCuadrado"></div>
        </div>
    )
}

export default SpinnerCuadrado